import React from 'react';
import { I18n as I } from 'react-redux-i18n';
import { Table } from 'antd';
import { Link } from 'react-router';
import Portlet from 'components/layout/Portlet';
import Counter from 'components/dashboard/Counter';

import { isNil } from 'vdlib';

import AuctionStatusCellRenderer from 'components/tables/datagrid-columns/AuctionStatusCellRenderer';
import TimeCellRenderer from 'components/tables/datagrid-columns/TimeCellRenderer';

const containerClassName = 'col-md-6 col-sm-6 col-12';

const columnDefs = [
  {
    title: 'SN',
    dataIndex: 'ID',
    width: 25,
    align: 'center',
  },
  {
    title: 'PART_NO',
    dataIndex: 'PartNumber',
    align: 'center',
    width: 110,
  },
  {
    title: 'DESCRIPTION',
    dataIndex: 'PartDescription',
  },
  {
    key: 'Brand',
    title: 'BRAND',
    dataIndex: 'VehicleBrand',
    width: 80,
    align: 'center',
    filterParams: { filterOptions: ['contains'] },
  },
  {
    key: 'Model',
    title: 'MODEL',
    dataIndex: 'VehicleModel',
    align: 'center',
  },
  //{ id: 'Region', title: I.t('REGION'), dataIndex: 'RegionID', valueGetter: params => LookupsHelper.getDescription(regions, params.data.RegionID), width: 60, align: 'center', cellStyle: cellStyle, filterParams: { filterOptions: ['contains'] } },
  {
    align: 'center',
    render: (_, record) => <AuctionStatusCellRenderer data={record} />,
    title: 'STATUS',
    width: 200,
  },
];

const AuctionsMerchantSummary = ({
  data,
  fetchMerchantAuctionsSummary,
  lang,
}) => {
  React.useEffect(() => {
    fetchMerchantAuctionsSummary();
  }, []); //eslint-disable-line

  const columns = React.useMemo(
    () =>
      columnDefs.map(c => ({
        ...c,
        title: I.t(c.title),
      })),
    [lang] //eslint-disable-line
  );

  const {
    LosingAuctions = [],
    LosingAuctionsCount,
    WinningAuctions = [],
    WinningAuctionsCount,
  } = data || {};

  return (
    <div>
      <div className="row">
        <Link className={containerClassName}>
          <Counter
            colorClassName="green"
            icon="fa fa-trophy"
            title={I.t('AUCTIONS_WINNING')}
            value={WinningAuctionsCount || ''}
          />
        </Link>
        <Link className={containerClassName}>
          <Counter
            colorClassName="red"
            icon="fa fa-thumbs-o-down"
            title={I.t('AUCTIONS_LOSING')}
            value={
              LosingAuctionsCount || LosingAuctionsCount === 0
                ? LosingAuctionsCount
                : ''
            }
          />
        </Link>
      </div>

      <Portlet title={I.t('AUCTIONS_LOSING_C')} icon="fa fa-thumbs-down">
        <Table columns={columns} dataSource={LosingAuctions} size="small" />
      </Portlet>

      <Portlet title={I.t('AUCTIONS_WINNING_C')} icon="fa fa-trophy">
        <Table columns={columns} dataSource={WinningAuctions} size="small" />
      </Portlet>
    </div>
  );
};

export default AuctionsMerchantSummary;
